import "dayjs/locale/en-gb";
import "dayjs/locale/nb";
import { WeekView as MantineWeekView, WeekViewProps } from "@mantine/schedule";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.css";

export const WeekView = (props: WeekViewProps) => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  return (
    <MantineWeekView
      {...props}
      radius={0}
      locale={currentLanguage.startsWith("no") ? "nb" : "en"}
      withHeader={false}
      classNames={{
        weekViewRoot: styles.root,
        weekViewHeader: styles.header,
        weekViewDay: styles.day,
        weekViewInner: styles.inner,
        weekViewSlotLabel: styles.label,
        weekViewDaySlot: styles.slot,
        weekViewAllDaySlotsLabel: styles.label,
        currentTimeIndicator: styles.indicator,
        currentTimeIndicatorLine: styles.indicatorLine,
        currentTimeIndicatorThumb: styles.indicator,
        weekViewDayLabel: styles.date,
        weekViewCorner: styles.date,
        weekViewWeekLabel: styles.label,
        weekViewWeekNumber: styles.label,
        weekViewDayNumber: styles.label,
        weekViewDayWeekday: styles.label,
        currentTimeIndicatorTimeBubble: styles.indicator,
        ...props.classNames,
      }}
      labels={{
        ...props.labels,
      }}
    />
  );
};

export default WeekView;
